
import { Component, Prop, Mixins } from 'vue-property-decorator';
import {
  Cascader,
  Dialog,
  Form,
  FormItem,
  Input,
  InputNumber,
  Button,
  RadioGroup,
  Radio,
  Select,
  Option,
} from 'element-ui';
import { IMenuForm } from '@/types/set.d';
import FormMixin from './formMixin';

@Component({
  components: {
    Cascader,
    Dialog,
    Form,
    FormItem,
    Input,
    InputNumber,
    Button,
    RadioGroup,
    Radio,
    Select,
    Option,
  },
})
export default class MenuBusModal extends Mixins(FormMixin) {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean

  @Prop({
    required: false,
    default: '添加模块',
  }) title!: string

  @Prop() tList: any

  @Prop({
    required: false,
  }) oldForm!: IMenuForm

  mounted() {
    if (this.title.includes('编辑') && this.oldForm !== this.form) this.form = this.oldForm;
  }

  // computed 返回 Cascader options
  get options() {
    return this.transformOptions(this.tList);
  }

  reset(close: boolean = false, refrsh: boolean = false) {
    if (close) this.$emit('update:visible', false);
    if (refrsh) this.$emit('refrsh');
    this.$log({
      title: `${this.log.name}${close ? '关闭' : '重置'}`,
      component: this.log.component,
    });
    this.resetForm();
  }

  /**
   * @author Terry
   * @description 将树结构转化为Cascader options 结构
   * @param { any } list
   */
  transformOptions(list: any) {
    const newOpts: Array<any> = [];
    return this.forEachTree(list, newOpts);
  }

  private forEachTree(list: any, newOpts: Array<any>) {
    for (let i = 0; i < list.length; i += 1) {
      const value: any = {
        value: list[i].pid,
        label: list[i].moduleTitle,
        path: list[i].moduleFolder,
      };
      newOpts.push(value);
      value.children = [];
      this.forEachTree(list[i].children, value.children);
      // if (list[i].type === 'MENU') {
      //   const value: any = {
      //     value: list[i].id,
      //     label: list[i].label,
      //     path: list[i].path,
      //   };
      //   newOpts.push(value);
      //   if (list[i].children.length > 0 && list[i].children[0].type === 'MENU') {
      //     value.children = [];
      //     this.forEachTree(list[i].children, value.children);
      //   }
      // }
    }
    return newOpts;
  }
}
